import APIV1 from '../../api/axios/APIV1';
import { GET_PENDING_OUTLETS, SET_PENDING_OUTLETS_LOADING, SET_PENDING_OUTLETS_ERROR } from '../types/PendingOutlets';

export const fetchPendingOutlets = (restaurantId) => async (dispatch) => {
    try {
        dispatch({ type: SET_PENDING_OUTLETS_LOADING, payload: true });

        // Only make API call if restaurant_id is available
        if (!restaurantId) {
            dispatch({
                type: SET_PENDING_OUTLETS_ERROR,
                payload: 'Restaurant ID is required to fetch pending outlets',
            });
            return;
        }

        const response = await APIV1.get(`/subscription/pending-outlets?restaurant_id=${restaurantId}`);

        if (response.success) {
            dispatch({
                type: GET_PENDING_OUTLETS,
                payload: {
                    data: response.data,
                    message: response.message,
                    restaurantId: restaurantId, // Pass the restaurant ID to store in state
                },
            });
        } else {
            dispatch({
                type: SET_PENDING_OUTLETS_ERROR,
                payload: response.message || 'Failed to fetch pending outlets',
            });
        }
    } catch (error) {
        console.error('Error fetching pending outlets:', error);
        dispatch({
            type: SET_PENDING_OUTLETS_ERROR,
            payload: 'Network error occurred while fetching pending outlets',
        });
    }
};
